/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 08.10.25
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {displayTypeFromNoteType, SessionNoteTypeEnum} from "@shared/Journal/SessionNoteTypeEnum";
import TagItem from "@shared/Tags/TagItem";
import {classToClass, Type} from "@qwoach/class-transformer-wrapper";
import QwoachFile from "@shared/Drive/QwoachFile";
import {JournalEntryType} from "@shared/Journal/JournalEntryType";
import {isObject} from "@/utils/helpers";

export default class SessionNoteItem extends BaseObject {

	title: string = null
	description: string = null
	content: string = null
	noteType: SessionNoteTypeEnum = null
	noteRefType: SessionNoteTypeEnum = null

	isReadonly: boolean = false

	@Type(() => TagItem)
	tags: TagItem[] = []

	defaultTagColor: string = null

	hasAttachments: boolean = false
	attachmentsFilter: string[] = []
	@Type(() => QwoachFile)
	attachmentsArray: QwoachFile[] = []

	constructor(options = {}) {
		super(options);
		let {items, ...rest} = options;
		if (items && Array.isArray(items)) {
			this.tags = items.map(item => new TagItem({
				title: item.title,
				description: item.description,
				color: options.defaultTagColor
			}));
		}

		this.applyOptions(rest);
	}

	addTag(item){
		if(isObject(item)){
			this.tags.push(new TagItem({...item, color: item.color || this.defaultTagColor}));
		}
	}

	getSessionNoteExecuted(options = {}){
		let sessionNote = classToClass(this)
		sessionNote.content = sessionNote.getSessionNoteString(options)
		return sessionNote
	}

	getSessionNoteString(options = {}){
		let extraSessionsArray = options.extraSessionsArray || []
		let lastSessionEmptyNote = options.lastSessionEmptyNote || "A note from the previous session will show up here (from the 'What Happened?' section)."
		let refNoteString = ''
		let isPrevSessionRef = this.noteType === SessionNoteTypeEnum.REF_PREV_SESSION
		let isBtSessionRef = this.noteType === SessionNoteTypeEnum.REF_BT_SESSION
		if(isPrevSessionRef || isBtSessionRef){
			console.log("SessionNoteItem.getSessionNoteString: this.extraSessionsArray", extraSessionsArray)
			let refSession = isPrevSessionRef
				? extraSessionsArray[extraSessionsArray.length - 1]
				: extraSessionsArray.find(session => session.getEntryByType?.([JournalEntryType.BEHAVIOUR_TREE_SESSION_PLAN]))
			console.log("SessionNoteItem.getSessionNoteString: refSession", refSession)
			let sessionPlan = refSession?.getEntryByType([JournalEntryType.TLSW_SESSION_PLAN, JournalEntryType.BEHAVIOUR_TREE_SESSION_PLAN, JournalEntryType.SESSION_PLAN])
			console.log("SessionNoteItem.getSessionNoteString: sessionPlan", sessionPlan)
			refNoteString = sessionPlan?.getNotesString(this.noteRefType) || lastSessionEmptyNote
			console.log("SessionNoteItem.getSessionNoteString: refNoteString", refNoteString)
		} else {
			refNoteString = this.content
		}
		return refNoteString
	}

	contentToString(){
		let displayType = displayTypeFromNoteType(this.noteType)

		switch (displayType) {
			case SessionNoteTypeEnum.GENERAL_TAGS:
				return this.tags.map(t=>t.title).join(', ')
			default:
				return this.content
		}

	}
}
